import { useNavigate } from "react-router-dom";
import { Flame, Mic, Users, Scale, FileText, Library } from "lucide-react";

/**
 * HomeQuickNav — fita de "pílulas" de navegação rápida logo abaixo da
 * primeira dobra. Cada pílula rola suavemente até a seção correspondente
 * (quando ela existe na home) ou navega para a página da editoria.
 *
 * Reduz a "paralisação na primeira dobra": dá ao recém-chegado rotas
 * imediatas e explícitas para o conteúdo, em vez de um muro de blocos.
 */
const PILLS = [
  { id: "ultimos-episodios", label: "Episódios", Icon: Flame },
  { id: "podcasts", label: "Podcasts", Icon: Mic },
  { id: "autores", label: "Autores", Icon: Users },
  { id: "radar", label: "Jurisprudência", Icon: Scale },
  { id: "blog", label: "Do Blog", Icon: FileText },
  { to: "/colunistas", label: "Colunas", Icon: FileText },
  { to: "/videos", label: "Acervo completo", Icon: Library },
];

export default function HomeQuickNav() {
  const navigate = useNavigate();

  const go = (pill) => {
    if (pill.to) {
      navigate(pill.to);
      return;
    }
    const el = document.getElementById(pill.id);
    if (el) {
      el.scrollIntoView({ behavior: "smooth", block: "start" });
    }
  };

  return (
    <nav
      aria-label="Atalhos rápidos por editoria"
      data-testid="home-quicknav"
      className="sticky top-16 z-30 border-y border-white/10 bg-[#0a0e17]/85 backdrop-blur-md"
    >
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-10">
        <div className="flex items-center gap-2.5 overflow-x-auto py-3 [-ms-overflow-style:none] [scrollbar-width:none] [&::-webkit-scrollbar]:hidden">
          <span className="hidden sm:inline text-[10px] uppercase tracking-[0.22em] text-slate-500 shrink-0 pr-1">
            Explorar
          </span>
          {PILLS.map(({ id, to, label, Icon }) => (
            <button
              key={id || to}
              type="button"
              onClick={() => go({ id, to, label })}
              data-testid={`quicknav-${(id || to).replace(/\W+/g, "-")}`}
              className="group inline-flex items-center gap-2 shrink-0 px-4 py-2 rounded-full border border-slate-700/80 bg-slate-900/60 text-sm text-slate-200 hover:border-red-500/70 hover:text-white hover:bg-red-500/10 transition-colors"
            >
              <Icon className="w-4 h-4 text-red-400 group-hover:text-red-300 transition-colors" />
              {label}
            </button>
          ))}
        </div>
      </div>
    </nav>
  );
}
